var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.39999C9.38 2.39999 7.25 4.52999 7.25 7.14999C7.25 9.71999 9.26 11.8 11.88 11.89C11.96 11.88 12.04 11.88 12.1 11.89C12.12 11.89 12.13 11.89 12.15 11.89C12.16 11.89 12.16 11.89 12.17 11.89C14.73 11.8 16.74 9.71999 16.75 7.14999C16.75 4.52999 14.62 2.39999 12 2.39999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.08 14.55C14.29 12.69 9.73996 12.69 6.92996 14.55C5.65996 15.4 4.95996 16.55 4.95996 17.78C4.95996 19.01 5.65996 20.15 6.91996 20.99C8.31996 21.93 10.16 22.4 12 22.4C13.84 22.4 15.68 21.93 17.08 20.99C18.34 20.14 19.04 19 19.04 17.76C19.03 16.53 18.34 15.39 17.08 14.55Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.cf48fc37945efb509c3ec6eecacbbe80.svg";
export { ForwardRef as ReactComponent };